import { render, staticRenderFns } from "./UserProp.vue?vue&type=template&id=4ec33206&scoped=true"
import script from "./UserProp.vue?vue&type=script&lang=js"
export * from "./UserProp.vue?vue&type=script&lang=js"
import style0 from "./UserProp.vue?vue&type=style&index=0&id=4ec33206&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec33206",
  null
  
)

export default component.exports